import { z } from 'zod';

// Swiss Phone Regex: +41 79 123 45 67 or 079 123 45 67
export const swissPhoneRegex = /^(\+41|0) ?([1-9][0-9]) ?([0-9]{3}) ?([0-9]{2}) ?([0-9]{2})$/;

export const authSchema = z.object({
  email: z.string().email('validation.email'),
  password: z.string().min(8, 'validation.passwordMin'),
  confirmPassword: z.string().optional().or(z.literal('')),
  firstName: z.string().min(2, 'validation.nameMin').optional().or(z.literal('')),
  lastName: z.string().min(2, 'validation.nameMin').optional().or(z.literal('')),
  companyName: z.string().min(2, 'validation.nameMin').optional().or(z.literal('')),
  address: z.string().min(5, 'validation.required').optional().or(z.literal('')),
  phone: z.string().regex(swissPhoneRegex, 'validation.phone').optional().or(z.literal('')),
  fullName: z.string().min(2, 'validation.nameMin').optional().or(z.literal('')),
}).refine((data) => {
  if (data.confirmPassword && data.password !== data.confirmPassword) {
    return false;
  }
  return true;
}, {
  message: 'validation.passwordMatch',
  path: ['confirmPassword'],
});

export const bookingSchema = z.object({
  name: z.string().min(2, 'validation.nameMin'),
  email: z.string().email('validation.email'),
  phone: z.string().regex(swissPhoneRegex, 'validation.phone'),
});

export const serviceSchema = z.object({
  name: z.string().min(2, 'validation.required'),
  description: z.string().min(5, 'validation.required'),
  price: z.number().positive('validation.required'),
  duration: z.number().positive('validation.required'),
  category: z.string().min(1, 'validation.required'),
});

export const barberShopSchema = z.object({
  name: z.string().min(2, 'validation.required'),
  address: z.string().min(5, 'validation.required'),
  opening_time: z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, 'validation.required'),
  closing_time: z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, 'validation.required'),
  phone: z.string().regex(swissPhoneRegex, 'validation.phone').optional(),
});

export const barberSchema = z.object({
  name: z.string().min(2, 'validation.required'),
  bio: z.string().min(5, 'validation.required'),
  user_id: z.string().uuid().optional().or(z.literal('')),
});

export const staffSchema = z.object({
  email: z.string().email('validation.email'),
  password: z.string().min(8, 'validation.passwordMin'),
});
